import {gql} from "@apollo/client";
import {client} from "graphql/client";

// 创建仓库管理员
export const CREATE_ACCOUNT_WAREHOUSE_MANAGER = gql`
    mutation CreateAccountWarehouseManager($input: AccountWarehouseManagerInput!) {
        createAccountWarehouseManager(input: $input)
    }
`;

// 更新仓库管理员
export const UPDATE_ACCOUNT_WAREHOUSE_MANAGER = gql`
    mutation UpdateAccountWarehouseManager($input: AccountWarehouseManagerInput!) {
        updateAccountWarehouseManager(input: $input)
    }
`;

export interface AccountWarehouseManagerInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    warehouseId: number;
    role: string;
}

export const createAccountWarehouseManager = async (input: AccountWarehouseManagerInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: CREATE_ACCOUNT_WAREHOUSE_MANAGER,
        variables: {input}
    });
    return data.createAccountWarehouseManager;
};

export const updateAccountWarehouseManager = async (input: AccountWarehouseManagerInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_WAREHOUSE_MANAGER,
        variables: {input}
    });
    return data.updateAccountWarehouseManager;
};